module.exports = __webpack_public_path__ + "static/media/slider-close-icon.c5847a81.svg";